<!-- Provider callback landing page.
     The member arrives here from the payment provider while the order is still
     being confirmed, then gets redirected on to success or failure - so the
     whole page is the wait.

     Just the express checkout's spinner, not its modal: there is no page
     behind this to dim and nothing to interrupt, so the panel, backdrop and
     overlay are all dropped and only the animation is kept. Reusing the same
     spinner is the point - the member has just watched it on the checkout
     page, so it reads as the same payment still going through.

     role="status" with aria-live announces the wait, and aria-busy tells
     assistive tech the page is working rather than finished. -->
<div class="payment-results" role="status" aria-live="polite" aria-busy="true">
  <!-- Inline rather than an asset, so it cannot flash in late over a payment
       that is already being confirmed. The spin and the dash march are
       separate animations on separate elements, so the arc's length changes
       while the whole ring turns - which is what reads as progress rather than
       a plain rotation. -->
  <svg class="payment-results__spinner" viewBox="0 0 50 50" aria-hidden="true" focusable="false">
    <circle class="payment-results__spinner-track" cx="25" cy="25" r="20" fill="none" stroke-width="4" />
    <circle
      class="payment-results__spinner-arc"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke-width="4"
      stroke-linecap="round"
    />
  </svg>

  <p class="payment-results__title">
    {{ 'payment.results.title' | translate: { fgbdefault: 'Confirming your payment' } }}
  </p>
  <p class="payment-results__description">
    {{ 'payment.results.description' | translate: { fgbdefault: 'Please wait and do not close this window.' } }}
  </p>
</div>
